module.exports = __webpack_public_path__ + "img/pic_2_zh.b22a4c16.png";